import axios from 'axios'
// Define las configuraciones básicas y la url base del backend.
export default() => {
  let tokenStr = sessionStorage.getItem("id_token");
  let token = sessionStorage.getItem("token");

  return axios.create({

    baseURL: 'https://www.tu-gps-app.com:8082/api/',
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Basic YWRtaW46YWRtaW4=',
      'Content-Type': 'application/json;charset=UTF-8',
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/ApiTraccar.js